import AddIcon from '@mui/icons-material/Add';
import { HomePageIds } from 'common/constant';

import { useState } from 'react';
import { DOC_URLS, openPdfInNewTab } from 'utils/openPdfInNewTab';

const FAQs = () => {
    const FAQsList = [
        {
            question: 'How does Be:Seen help my practice grow?',
            answer: (
                <>
                    Be:Seen connects you directly with patients{' '}
                    <span className="font-semibold">who pay out-of-pocket</span> at{' '}
                    <span className="font-semibold"> transparent, pre-set prices</span>
                    —eliminating insurance headaches, claim denials, and payment delays. You get paid upfront, reduce
                    administrative burdens, and fill your schedule with cash-paying patients.
                </>
            ),
        },
        {
            question: 'What are the benefits of offering direct-pay services through Be:Seen?',
            answer: (
                <>
                    With Be:Seen, you <span className="font-semibold"> set your own rates </span> and get paid{' '}
                    <span className="font-semibold"> immediately at booking</span>—no more waiting for insurance
                    reimbursements. Our marketplace brings high-intent,
                    <span className="font-semibold"> paying patients to your practice</span>, helping you grow revenue
                    while spending <span className="font-semibold"> less time on billing and paperwork.</span>
                </>
            ),
        },
        {
            question: 'Can I still keep my existing patients and insurance-based practice?',
            answer: (
                <>
                    Yes! Be:Seen is an <span className="font-semibold">additional revenue stream</span> for your
                    practice. You can continue seeing insurance patients while also attracting direct-pay patients{' '}
                    <span className="font-semibold">without network restrictions or preauthorizations.</span> Many
                    providers use Be:Seen to fill last-minute openings or offer cash-pay services alongside their
                    existing practice.
                </>
            ),
        },
        {
            question: 'How do I join, and what does it cost?',
            answer: (
                <>
                    Joining Be:Seen is <span className="font-semibold">free</span>—there are no upfront costs or
                    subscription fees. We only take a small percentage{' '}
                    <span className="font-semibold">when you successfully book a patient</span>, meaning you keep more
                    of your earnings compared to traditional insurance reimbursements.
                </>
            ),
        },
        {
            question: 'How does Be:Seen handle scheduling and payments?',
            answer: (
                <>
                    Our platform integrates directly with your scheduling system, making it easy to manage appointments.
                    Patients pay <span className="font-semibold">upfront at booking</span>, so there’s{' '}
                    <span className="font-semibold">
                        no chasing payments, no claims processing, and no financial risk
                    </span>{' '}
                    from unpaid visits.
                </>
            ),
        },
    ];

    const openMailClient = () => {
        window.location.href = 'mailto:info@beseen.com';
    };

    const FAQ = ({ question, answer }) => {
        const [isOpen, setIsOpen] = useState(false);
        return (
            <div className="flex min-h-24 px-8 py-6 lg:px-10 lg:py-8 justify-between items-center self-stretch rounded-lg bg-white cursor-pointer hover:bg-gray-50 transition-colors duration-200"
            onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex flex-col gap-3 w-full">
                    <div className="flex justify-between w-full">
                        <span className="text-[#3E3E4A] text-[20px] font-semibold leading-normal">{question}</span>
                        <span onClick={() => setIsOpen(!isOpen)} className="cursor-pointer flex-shrink-0 min-w-[24px] min-h-[24px] flex items-center justify-center">
                            <AddIcon 
                                className={`text-[#FF5F39] transition-transform duration-300 ease-in-out ${
                                    isOpen ? 'rotate-45' : 'rotate-0'
                                }`}
                                style={{ fontSize: '24px' }}
                            />
                        </span>
                    </div>
                    {isOpen && <span className="text-[#3E3E4A] text-[16px] leading-normal pt-3">{answer}</span>}
                </div>
            </div>
        );
    };
    return (
                <div
                    className="flex py-[80px] px-6 md:pt-[140px] md:px-12 md:pb-[140px] lg:pt-[140px] lg:pb-[140px] lg:px-24 xl:pt-[140px] xl:pb-[140px] xl:px-24 bg-opacity-10 bg-[#184353] justify-center"
                    id={HomePageIds.faqs}
                >
            <div className="flex flex-col gap-16 w-full lg:w-[80%] xl:w-[60%] max-w-[890px]">
                <span className="text-center text-[48px] font-bold leading-tight text-[#3E3E4A]">Common Questions</span>

                <div className="flex flex-col gap-5">
                    {FAQsList.map((faq) => (
                        <FAQ question={faq.question} answer={faq.answer} />
                    ))}
                </div>

                <div className="flex flex-col gap-5 text-center">
                    <p className="text-[16px] font-normal text-[#666]">
                        For details on our pricing and payment rules, please refer to our{' '}
                        <span className="text-[#FF5F39] cursor-pointer hover:underline" onClick={()=>openPdfInNewTab(DOC_URLS.termsAndConditionDoc)}>Terms and Conditions</span>.
                    </p>
                    <p className="text-[16px] font-normal text-[#666]">
                        ‍Still have questions about Be:Seen, or want a demo, email us at{' '}
                        <span className="text-[#FF5F39] cursor-pointer hover:underline" onClick={openMailClient}>
                            info@beseenhealth.com
                        </span>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
};
export default FAQs;
